import styled from "styled-components";
import { useState } from "react";
import { useDispatch } from 'react-redux'
import { setCredentials } from '../features/auth/authSlice'
import { useLoginMutation, useSignupReqMutation } from '../features/auth/authApiSlice'
import usePersist from '../features/hooks/usePersist'
import { useNavigate, Link } from 'react-router-dom'
import useTitle from '../features/hooks/useTitle'
import { useGetemailmasterQuery } from "../features/emailmaster/emailMasterApiSlice";
import { set } from "react-hook-form";
import { useGetDraftUsersQuery, useUpdateDraftUserMutation } from "../features/draftusers/draftUsersApiSlice";
import { useGetUsersQuery } from "../features/users/usersApiSlice";
import Topbarlogin from "./Topbar-login";
import { TextField, Paper, InputAdornment } from "@mui/material";
import { CommonButton } from '../Styles/CommonStyles';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import cwcLogo from '../images/logo-final.png';

// import {mobile} from "../responsive";
const Container = styled.div`
  width: 100vw;
  height: calc(100vh);
  background-color:#edeff6;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 25%;
  height: 300px;
  padding: 20px;
  background-color: #57ccf4;
  border-radius:6%;  
`

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 10px 0;
  padding: 10px;
`;

const Button = styled.button`
  width: 40%;
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;
  margin-bottom: 10px;
  &:disabled{
    color: green;
    cursor: not-allowed;
  }
`;

const Linke = styled.a`
  margin: 5px 0px;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
`;

const Error = styled.span`
  color:Red;
`

const SignupReqContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #a961f1 0%, #57ccf4 100%);
  padding: 20px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="water" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="%23ffffff" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23water)"/></svg>');
    pointer-events: none;
  }
`;

const SignupReqWrapper = styled(Paper)`
  width: 100%;
  max-width: 500px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  background: white;
  position: relative;
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

const LogoContainer = styled.div`
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
`;

const LogoImage = styled.img`
  height: 95px;
  width: auto;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  flex-shrink: 0;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`;

const LogoText = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #5C5891;
  margin: 0;
  line-height: 1.2;
`;

const Subtitle = styled.p`
  color: #a961f1;
  margin: 4px 0 0 0;
  font-size: 18px;
  font-weight: 600;
`;

const StyledForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const StyledTextField = styled(TextField)`
  & .MuiOutlinedInput-root {
    border-radius: 12px;
    background-color: #f8f9fa;
    
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: #a961f1;
    }
    
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #5C5891;
      border-width: 2px;
    }
  }
  
  & .MuiInputLabel-root.Mui-focused {
    color: #5C5891;
  }
`;

const SignupReqButton = styled(CommonButton)`
  && {
    height: 50px;
    background: linear-gradient(45deg, #a961f1, #57ccf4);
    color: white;
    font-weight: 600;
    text-transform: none;
    border-radius: 12px;
    margin-top: 10px;
    font-size: 16px;
    box-shadow: 0 4px 15px rgba(169, 97, 241, 0.3);
    
    &:hover {
      background: linear-gradient(45deg, #5C5891, #57ccf4);
      box-shadow: 0 6px 20px rgba(169, 97, 241, 0.4);
      transform: translateY(-1px);
    }
    
    &:disabled {
      background: #e0e0e0;
      box-shadow: none;
      transform: none;
    }
  }
`;

const LinksContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;

const StyledLink = styled(Link)`
  color: #a961f1;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
    color: #5C5891;
  }
`;

const ErrorMessage = styled.div`
  color: #d32f2f;
  background-color: #ffebee;
  padding: 10px;
  border-radius: 12px;
  font-size: 14px;
  margin-top: 10px;
  text-align: center;
`;

const SignupReq = () => {
  useTitle("Central Water Commission - Signup Request");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [signupReq, { isLoading }] = useSignupReqMutation();

  const { emailmaster } = useGetemailmasterQuery("emailmasterList", {
    selectFromResult: ({ data }) => ({
      emailmaster: data?.entities
    }),
  });

  const { draftuserdata } = useGetDraftUsersQuery("draftusersList", {
    selectFromResult: ({ data }) => ({
      draftuserdata: data?.entities
    }),
  });

  const { userdata } = useGetUsersQuery("userlist", {
    selectFromResult: ({ data }) => ({
      userdata: data?.entities
    }),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email?.length) {
      setError("Email is required");
      return;
    }

    // Check if email exists in draftusers
    if (Object.values(draftuserdata)?.map(x => x.email)?.includes(email)) {
      setError("Request already submitted earlier. Please contact Admin");
      return;
    }

    // Check if email exists in users
    if (Object.values(userdata)?.map(x => x.email)?.includes(email)) {
      setError(`User account already exists with email: ${email}. Please use different Email Id`);
      return;
    }

    // Check if email exists in emailmaster
    if (!Object.values(emailmaster)?.map(x => x.name)?.includes(email)) {
      setError("Email not registered. Please contact admin");
      return;
    }

    try {
      const response = await signupReq({ email }).unwrap();
      if (response.success) {
        alert("Request sent successfully. Please check your email");
        setEmail("");
        navigate('/login');
      } else {
        setError("Request failed. Please try again.");
      }
    } catch (err) {
      setError(err?.data?.message || "Request failed. Please try again.");
    }
  };

  return (
    <SignupReqContainer>
      <SignupReqWrapper elevation={3}>
        <LogoContainer>
          <LogoImage src={cwcLogo} alt="Central Water Commission Logo" />
          <TextContainer>
            <LogoText>Central Water Commission</LogoText>
            <Subtitle>Asset Management System</Subtitle>
          </TextContainer>
        </LogoContainer>

        <StyledForm onSubmit={handleSubmit}>
          <StyledTextField
            label="Email Address"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            variant="outlined"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailOutlinedIcon sx={{ color: '#a961f1' }} />
                </InputAdornment>
              ),
            }}
          />

          <SignupReqButton type="submit" disabled={isLoading}>
            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Request Access"}
          </SignupReqButton>

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <LinksContainer>
            <StyledLink to="/">Already have an account? Sign In</StyledLink>
          </LinksContainer>
        </StyledForm>
      </SignupReqWrapper>
    </SignupReqContainer>
  );
};

export default SignupReq;